import type { Intent } from '@jet/environment/dispatching/base/intent';
import type { Page } from '../../models/page';
import type { PageChangeInstruction } from './../../models/invalidation/change-instruction/PageChangeInstruction';

export interface RefreshIntentMetadata {
    currentSort?: string;
    selectedId?: string;
}

export interface RefreshIntent<T> extends Intent<T> {
    reason: string;
    metadata?: RefreshIntentMetadata;
}

// Generic intent used for refreshing any page
export interface RefreshPageIntent
    extends RefreshIntent<PageChangeInstruction> {
    intent: Intent<Page>;
    $kind: 'RefreshPageIntent';
}

export function makeRefreshPageIntent(
    intent: Intent<Page>,
    reason: string,
    metadata?: RefreshIntentMetadata,
): RefreshPageIntent {
    return {
        $kind: 'RefreshPageIntent',
        intent,
        reason,
        metadata,
    };
}
